import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchAllPatients } from './api';

/** The full tenant-wide roster — see fetchAllPatients's own comment for why. */
export function usePatients() {
  return useQuery({
    queryKey: keys.patients.list(),
    queryFn: fetchAllPatients,
  });
}
